import { useQuery } from '@tanstack/react-query';
import { API_PATHS } from 'api';
import { Campaign, CampaignType } from 'models/Campaign';
import { queryClient } from 'react-query';

const fetchCampaign = async (
  id: string,
  campaignType: CampaignType,
): Promise<Campaign> => {
  const path =
    campaignType === CampaignType.Personal
      ? API_PATHS.personalCampaigns.getCampaign(id)
      : API_PATHS.campaigns.getCampaign(id);
  return queryClient.fetchQuery<Campaign>({
    queryKey: [path, { id }],
  });
};

const useCampaign = (id: string, campaignType: CampaignType) => {
  return useQuery({
    queryKey: [
      `${campaignType === CampaignType.Personal ? 'personal-' : ''}campaign`,
      { id },
    ],
    queryFn: () => fetchCampaign(id, campaignType),
    enabled: !!id,
  });
};

export default useCampaign;
